/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var SearchOutlineIcon = function SearchOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3864 18.2109C14.8846 19.3345 13.02 20 11.0001 20C6.0295 20 2.00006 15.9706 2.00006 11C2.00006 6.02944 6.0295 2 11.0001 2C15.9706 2 20.0001 6.02944 20.0001 11C20.0001 13.2281 19.1904 15.267 17.8493 16.8387L22.6757 21.2629L21.3243 22.7372L16.3864 18.2109ZM18.0001 11C18.0001 14.866 14.8661 18 11.0001 18C7.13407 18 4.00006 14.866 4.00006 11C4.00006 7.13401 7.13407 4 11.0001 4C14.8661 4 18.0001 7.13401 18.0001 11Z"
  }));
};
export default SearchOutlineIcon;